// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"featuredNews-module--wrapper--1alNh","body":"featuredNews-module--body--2gQkO","cardsContainer":"featuredNews-module--cardsContainer--2yHFA"};